import React, { useEffect, useRef, useState } from "react";
import search from "../images/search.svg";
import download from "../images/searchBarDownload.svg";
import filter from "../images/filter.svg";
import axios from "axios";
import { KeyboardArrowDown } from "@mui/icons-material";
import { decryptText } from "../utils/cipherText";
import GreenButton from "./GreenButton";
import { GoDownload } from "react-icons/go";
import { LuFilter } from "react-icons/lu";
import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { set } from "date-fns";
import { FiFilter } from "react-icons/fi";
import FinsireButton from "./FinsireButton";
import { MdOutlineCancel } from "react-icons/md";
import { TbColumns3 } from "react-icons/tb";

const SearchTopBar = ({
  setPageNo,
  downloadPageWord,
  filterShow,
  setSearchQuery,
  filterList,
  setFilterShow,
  selectedFilter,
  setSelectedFilter,
  searchQuery,
  inputref,
  showButton,
  optionSelected,
  setOptionSelected,
  statusFilter,
  setStatusFilter,
  triggerFilter,
  setTriggerFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setEmiValue,
  emiValue,
  filterApplied,
  setFilterApplied,
  od,
  leafColumns,
  tempVisibility,

  setTempVisibility,
  setVisibleColumns,
  columnSettings,
  setColumnSettings
}) => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const ref = useRef(null);
  const selectRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(null);


  const handlePageDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/download_${
          // (downloadPageWord === "transactions" && "transaction") ||
          // (downloadPageWord === "distributors" && "distributor") ||
          // "selected"
          downloadPageWord
        }_csv?page_name=${downloadPageWord}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res.data.download_url);

      const link = document.createElement("a");
      link.href = res.data.download_url;
      link.download = "data.csv";
      link.textContent = "Download CSV";
      // Append the link to the DOM and trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up the object URL
      URL.revokeObjectURL(link.href);
      // Remove the link from the DOM
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  function toggleFilterDropdown(event) {
    setFilterShow((prev) => !prev);
    // setOptionSelected("");
    event.stopPropagation();
  }
  const toggleTempVisibility = (columnId) => {
    setTempVisibility((prev) => {
      // Directly toggle the specific column's visibility
      return {
        ...prev,
        [columnId]: !(prev[columnId] ?? true), // Default to true if undefined
      };
    });
  };

  const options = [
    { value: "disbursement_status", label: "Transaction Status" },
    { value: "transaction_status", label: "EMI Status" },
    { value: "last_transaction_date", label: "Last Transaction Date" },
  ];

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const optionsDisbursement = [
    { value: "disbursed", label: "Disbursed" },
    { value: "not disbursed", label: "Not Disbursed" },
  ];

  const optionsEmiMissed = [
    { value: "success", label: "Success" },
    { value: "failed", label: "Failed" },
  ];

  const clearDataOnFilter = () => {
    setEmiValue("");
    setStatusFilter("");
    setStartDate(null);
    setEndDate(null);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && selectRef.current.contains(event.target)) {
      return;
    }
    if (ref.current && !ref.current.contains(event.target)) {
      setFilterShow(false);
    }
  };
  const handleApply = () => {
    // console.log(tempVisibility, "temp-befores");
    // Use setColumnVisibility to update the table's visibility state
    // table.setColumnVisibility(tempVisibility);
    setVisibleColumns(tempVisibility);
    setColumnSettings(false);
  };

  const disableDateRanges = startDate
    ? [{ start: new Date(0), end: new Date(startDate - 1) }]
    : [];

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="flex w-full lg:max-h-14 pt-2">
      <div className="flex flex-row justify-between items-center w-full">
        <div>
          <p className="text-[#262626] text-base font-bold">
            {od ? "Transactions" : "Repayment Transactions"}
          </p>
        </div>
        <div className="flex items-center gap-2 relative">
          {od && (
            <>
              <div className=" relative">
                {" "}
                <button
                  onClick={() => {
                    setFilterShow(false);
                    setColumnSettings(!columnSettings);
                  }}
                  className=" p-1 border border-[#DADADA] rounded "
                >
                  <TbColumns3 color="#606668" size={17} />
                </button>
                {columnSettings && (
                  <div className=" absolute bg-white p-3 rounded-lg shadow-lg right-[1px] min-w-[197px] w-fit z-[100]">
                    <div className=" w-full flex items-center mb-2">
                      <TbColumns3
                        color="#606668"
                        className="ml-[2px]"
                        width={13}
                        height={11}
                      />
                      <p className=" ml-2 text-[#393939] text-sm font-semibold ">
                        View Column
                      </p>
                    </div>
                    {leafColumns.map((column) => (
                      <div
                        key={column.id}
                        className=" py-[2px] px-[3.5px] flex items-center h-6"
                      >
                        <input
                          className="  w-[13px] h-[13px]"
                          disabled={column.columnDef.enableHiding === false}
                          type="checkbox"
                          checked={tempVisibility[column.id] ?? true} // Default to visible
                          onChange={() => toggleTempVisibility(column.id)}
                        />{" "}
                        <p className=" ml-[9px] text-[#606668] text-sm font-medium">
                          {column.id}{" "}
                        </p>
                      </div>
                    ))}
                    <div className=" flex justify-between items-center mt-2">
                      <button
                        onClick={() => {
                          setTempVisibility([]);
                          setVisibleColumns([]);
                          setColumnSettings(false);
                        }}
                        className=" w-[82.5px]  h-6 items-center flex justify-center border border-[#00394d] text-[#00394d] font-semibold text-xs rounded"
                      >
                        Reset
                      </button>
                      <button
                        onClick={handleApply}
                        className=" w-[82.5px]  h-6 items-center flex justify-center bg-[#00394d] text-white font-semibold text-xs rounded"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          <div className="relative">
            {!od && (
              <div
                ref={selectRef}
                className={`  rounded p-1 cursor-pointer text-white flex items-center ${
                  filterApplied
                    ? "bg-[#00394D]"
                    : "border-[#DADADA] border border-solid"
                }`}
                onClick={(e) => toggleFilterDropdown(e)}
              >
                <FiFilter
                  size={"17px"}
                  color={filterApplied ? "#ffffff" : "#656565"}
                />{" "}
                <span className={`${filterApplied && "ml-1"} text-[14px]`}>
                  {filterApplied && " ( 1 )"}
                </span>
              </div>
            )}

            {filterShow && (
              <div
                ref={ref}
                className=" w-[190px] px-2 rounded-b-lg absolute top-7.5 right-0 z-10 bg-white pt-[12px] text-xs font-medium shadow-md pb-2 "
              >
                <p className="text-xs font-semibold text-[#262626] mb-2">
                  Filter by
                </p>
                <Select
                  value={
                    optionSelected === ""
                      ? ""
                      : options.find((obj) => obj.value === optionSelected)
                  }
                  options={options}
                  onChange={(e) => setOptionSelected(e.value)}
                />
                {optionSelected === "disbursement_status" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <Select
                      value={
                        statusFilter !== "" &&
                        optionsDisbursement.find(
                          (obj) => obj.value === statusFilter
                        )
                      }
                      options={optionsDisbursement}
                      placeholder="-Select Status-"
                      onChange={(e) => {
                        clearDataOnFilter();
                        setStatusFilter(e.value);
                      }}
                    />
                  </div>
                ) : optionSelected === "transaction_status" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <Select
                      value={
                        emiValue !== "" &&
                        optionsEmiMissed.find((obj) => obj.value === emiValue)
                      }
                      options={optionsEmiMissed}
                      onChange={(e) => {
                        clearDataOnFilter();
                        setEmiValue(e.value);
                      }}
                      placeholder="-Select Status-"
                    />
                  </div>
                ) : optionSelected === "last_transaction_date" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <p className="text-xs font-semibold text-[#262626]">
                      Start date
                    </p>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setEmiValue("");
                        setStatusFilter("");
                        setStartDate(date);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                    <p className="text-xs font-semibold text-[#262626]">
                      End date
                    </p>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        setEmiValue("");
                        setStatusFilter("");
                        setEndDate(date);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      excludeDateIntervals={disableDateRanges}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className=" w-full flex justify-between">
                  <button
                    className=" py-[3px] px-2 rounded w-[46%] h-8 font-medium bg-[#00394d] text-white mt-3"
                    onClick={() => {
                      if (
                        optionSelected !== "" &&
                        (statusFilter !== "" ||
                          emiValue !== "" ||
                          startDate !== null ||
                          endDate !== null)
                      ) {
                        setTriggerFilter(!triggerFilter);
                        setFilterApplied(true);
                        setFilterShow(false);
                      }
                    }}
                  >
                    Filter
                  </button>

                  <button
                    className=" py-[3px] px-2 rounded w-[46%] h-8 font-medium  text-[#00394d] border border-[#00394d] mt-3"
                    onClick={() => {
                      setOptionSelected("");
                      clearDataOnFilter();
                      setFilterApplied(false);
                      setTriggerFilter(!triggerFilter);
                      setFilterShow(false);
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>
          <form className="">
            <div className="relative w-[70%]">
              <div className="relative w-[210px]">
                <input
                  type="text"
                  id="search-field"
                  name="search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => {
                    if (od) {
                      setPageNo(1);
                    }

                    setSearchQuery(e.target.value);
                  }}
                  className="w-full text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] pr-10 focus:outline-none"
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 focus:outline-none"
                  >
                    <MdOutlineCancel color="#00394d" />
                  </button>
                )}
              </div>
            </div>
          </form>
          {userType !== "distributors" && !od && showButton !== false && (
            <div onClick={() => handlePageDownload()}>
              <FinsireButton text={"Download"} icon={GoDownload} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchTopBar;
